export const preferencesRoutes = [
  {
    path: '/preferences',
    name: 'preferences',
    meta: {
      requiresAuth: true // all app paths require authentication
    },
    component: () => import(/* webpackChunkName: "preferences" */ './Preferences.vue'),
    children: [
      {
        path: ':id',
        name: 'user-preference',
        component: () => import('./Preferences.vue')
      }
    ]
  }
];
